<div class="notificacoes bg-surface-enabled-primary max-h-[80vh] shadow border border-stroke-enabled mt-[8px]">

    <div class="notificacoes-header d-flex justify-content-between" (click)="handleStopPropagation($event)">
        <span>Notificações</span>

        @if (notificacoes.length) {
            <button (click)="handleVerTodas()">Ver todas</button>
        }
    </div>

    <ul>
        @for (notificacao of notificacoes; track notificacao.id) {
            <li class="notificacoes__item" [class.lida]="notificacoesLidas.includes(notificacao.id)" [matTooltip]="notificacao.titulo" (click)="handleOpenNotificacao($event, notificacao)">
                <mat-icon [svgIcon]="notificacao.categoria.icon"></mat-icon>
                
                <span class="notificacoes__item-title txt-ellipsis">{{notificacao.titulo}}</span>
                <span class="notificacoes__item-date">{{notificacao.tempoCriacao}}</span>
                <span class="notificacoes__item-description txt-ellipsis">{{notificacao.descricao.texto}}</span>

            </li>
        } @empty {
            <div class="py-[10px] flex items-center justify-center">
                <span >Não há notificações!</span>
            </div>
        }
    </ul>

</div>